export default "__VITE_ASSET__CjR7$xAA__"